export class ShippingRate {
  constructor(formData, callback, loadingSpinnerElement) {
    // this.products = product;
    this.formData = formData;
    // this.delivery_address = delivery_address;
  }

  getShippingResult() {
    var _t = this;
    return new Promise((resolve, reject) => {
      var request = $.ajax({
        url: '/checkout/shipping_rate2',
        method: 'POST',
        dataType: 'json',
        data: this.formData
      });

      request.done(function(data) {
        resolve(data);
      });

      request.fail(function(jqXHR, textStatus) {
        reject(textStatus);
        // remove overlay
        // _t.toggleLoadingSpinner(_t.loadingSpinnerElement, "hide");
        // console.log("Request failed: " + textStatus);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./public/src/js/ShippingRate.js